import { ReusableCustomQuestionField } from "../interfaces/ReusableCustomQuestionField";
import { CustomQuestionField } from "../interfaces/Workflow";

export function convertReusableQuestionToWorkflowQuestionField(
  customQuestionField: ReusableCustomQuestionField,
): CustomQuestionField {
  return {
    id: customQuestionField.id.toString(),
    name: customQuestionField.questionText,
    type: customQuestionField.type,
    value: "",
    readonly: customQuestionField.readOnly,
    mandatory: customQuestionField.mandatory,
    validation: customQuestionField.validation,
    validation_message: customQuestionField.validationMessage,
    options: customQuestionField.options,
  };
}

export function convertWorkflowQuestionFieldToReusableQuestion(
  customQuestionField: CustomQuestionField,
  customerId: number,
): ReusableCustomQuestionField {
  let numericId: number | undefined = Number(customQuestionField.id);
  if (Number.isNaN(numericId)) numericId = 0;

  return {
    customerId: customerId,
    id: numericId,
    questionText: customQuestionField.name,
    type: customQuestionField.type,
    readOnly: customQuestionField.readonly,
    mandatory: customQuestionField.mandatory,
    validation: customQuestionField.validation,
    validationMessage: customQuestionField.validation_message,
    options: customQuestionField.options,
  };
}
